module.exports = __webpack_public_path__ + "media/images/pr_detail/users-e9d48a64b694efbfd45f8f281bd2ef6e.png";